import React, { useState } from 'react'

import { useSelector } from 'react-redux';
import { selectStatus } from '@state/selectors';
import { selectUser } from '@state/selectors';


const cart = require('@resources/cart.png');
const dcart = require('@resources/cart-disabled.png');


const saleId = '';

const bondText = 'Redeem this to add towards your donator rank and spend the credits in the donator shop!';

const images = [
    require('@resources/pvm-booster.png'),
    require('@resources/pvm-warrior.png'),
    require('@resources/pvm-ranger.png'),
    require('@resources/pvm-mage.png'),
    require('@resources/pvm-master.png')
]
const packages = [
    [
        {qty: '1X •', item: '$5 Bond:', description: bondText},
        {qty: '30X •', item: 'Super Restores', description: ''},
        {qty: '20X •', item: 'Saradomin Brews', description: ''},
        {qty: '75X •', item: 'Angler Fish', description: ''},
    ],
    [
        {qty: '3X •', item: '$5 Bond:', description: bondText},
        {qty: '35X •', item: 'Super Restores', description: ''},
        {qty: '25X •', item: 'Saradomin Brews', description: ''},
        {qty: '100X •', item: 'Angler Fish', description: ''},
        {qty: '20X •', item: 'Overload', description: ''},
        {qty: '1X •', item: 'Melee Pack:', description: 'Contains a random high tier melee weapon, as well as a chance at a bandos armour piece.'},

    ],
    [
        {qty: '3X •', item: '$5 Bond:', description: bondText},
        {qty: '35X •', item: 'Super Restores', description: ''},
        {qty: '25X •', item: 'Saradomin Brews', description: ''},
        {qty: '100X •', item: 'Angler Fish', description: ''},
        {qty: '20X •', item: 'Super Ranging Potions', description: ''},
        {qty: '1X •', item: 'Range Pack:', description: 'Contains a random high tier range weapon, as well as a chance at an armadyl armour piece.'},
    ],
    [
        {qty: '3X •', item: '$5 Bond:', description: bondText},
        {qty: '35X •', item: 'Super Restores', description: ''},
        {qty: '25X •', item: 'Saradomin Brews', description: ''},
        {qty: '100X •', item: 'Angler Fish', description: ''},
        {qty: '20X •', item: 'Super Magic Potions', description: ''},
        {qty: '1X •', item: 'Mage Pack:', description: 'Contains a random high tier magic weapon, as well as a chance at an infinity robes piece.'},
    ],
    [
        {qty: '2X •', item: '$25 Bond:', description: bondText},
        {qty: '35X •', item: 'Super Restores', description: ''},
        {qty: '25X •', item: 'Saradomin Brews', description: ''},
        {qty: '100X •', item: 'Angler Fish', description: ''},
        {qty: '20X •', item: 'Overload', description: ''},
        {qty: '20X •', item: 'Super Magic Potions', description: ''},
        {qty: '20X •', item: 'Super Ranging Potions', description: ''},
        {qty: '1X •', item: 'Melee Pack:', description: 'Contains a random high tier melee weapon, as well as a chance at a bandos armour piece.'},
        {qty: '1X •', item: 'Mage Pack:', description: 'Contains a random high tier magic weapon, as well as a chance at an infinity robes piece.'},
        {qty: '1X •', item: 'Range Pack:', description: 'Contains a random high tier range weapon, as well as a chance at an armadyl armour piece.'},
    ]
];



const PvmPack = () => {


    const isAuth = useSelector(selectStatus);
    const user = useSelector(selectUser);

    const [pack, setPack] = useState(packages[0]);
    const [img, setImg] = useState(images[0]);
    const [watchList] = useState(document.getElementsByName('watch'));

    const updatePackage = (e) => {
        setImg(images[e.target.selectedIndex]);
        setPack(packages[e.target.selectedIndex]);
    }


    const config = {  attributes: true, childList: true, characterData: true }
    
    const callback = function(mutationsList, observer) {
        for (let m of mutationsList) {
            if (m.attributeName === 'value') {
                m.target.classList.add('flash');
                setTimeout(() => {
                    m.target.classList.remove('flash');
                }, 3000);

            }
        }
    }
    const observer = new MutationObserver(callback);

    for (let el of watchList) {
        observer.observe(el, config);
    }

    return (
        <div className="store-item-paypal">
            
            <form target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">
                <input type="hidden" name="cmd" value="_s-xclick" />
                <input type="hidden" name="hosted_button_id" value="4E5XTBGEY93SN" />
                <input type="hidden" name="on1" value={user?.username} />
                <input type="hidden" name="on2" value={saleId} />
                <table>
                    <thead>
                        <tr><td><input type="hidden" name="on0" value="Package" />Package</td></tr>
                    </thead>
                    <tbody>
                        <tr><td>
                        <select name="os0" onChange={updatePackage}>
                            <option value="Booster">Booster $10.00 USD</option>
                            <option value="Warrior">Warrior $25.00 USD</option>
                            <option value="Ranger">Ranger $25.00 USD</option>
                            <option value="Mage">Mage $25.00 USD</option>
                            <option value="Slayer Master">Slayer Master $60.00 USD</option>
                        </select>  
                        </td></tr>
                    </tbody>
                </table>
                <input type="hidden" name="currency_code" value="USD" />
                <br/>
                <input className={isAuth ? '' : 'd-cursor'} disabled={!isAuth} type="image" src={isAuth ? cart : dcart} border="0" name="submit" alt="PayPal - The safer, easier way to pay online!" />
                <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1" />
            </form>


            <div>
            <img draggable="false" alt="items in the currently selected package" className='item-img' src={img} />
            {pack.map((item, index) => (
                <p key={index}><span className='qty' name="watch" value={item.qty}>{item.qty}</span> <span className='item-name' name="watch" value={item.item}>{item.item}</span> <span className='desc'>{item.description}</span></p>
            ))}

            </div>
        </div>
    )
}

export default PvmPack;
